export default "__VITE_ASSET__BXytNUQ$__"